import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row mt-2" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-calendar-star fa-4x" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "text-white fw-bolder fs-6 cursor-pointer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block" }, null, -1)
const _hoisted_10 = { class: "d-block d-md-none col-12 col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus text-primary mb-5 fs-2x" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fs-5 fw-bold mb-2" }, "Add Call Type", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.callTypes.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "call types help you color-code your calendars"
          }, {
            image: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "btn btn-primary d-flex flex-column flex-center mt-4 fs-3",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addDefaults && _ctx.addDefaults(...args)))
              }, "Add Defaults For Me "),
              _createElementVNode("div", {
                class: "btn btn-sm btn-secondary d-flex flex-column flex-center fs-3 mt-4",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addCallType && _ctx.addCallType(...args)))
              }, "Add Custom Call Type ")
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.callTypes, (callType) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-md-3",
                  key: callType.callTypeId
                }, [
                  _createElementVNode("div", {
                    class: "d-flex align-items-center border border-dotted mb-4",
                    onClick: ($event: any) => (_ctx.updateCallType(callType))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["bullet bullet-vertical h-40px me-4", `bg-${_ctx.getCallTypeColor(callType.color)}`])
                    }, null, 2),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(callType.name), 1),
                      _hoisted_9
                    ])
                  ], 8, _hoisted_6)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "d-flex card flex-center bg-light-primary border-primary border border-dashed p-8 mb-6",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addCallType && _ctx.addCallType(...args)))
                }, _hoisted_13)
              ])
            ])
          ]))
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}